import { Injectable } from '@angular/core';
import { DateTime } from 'luxon';

@Injectable({ providedIn: 'root' })
export class TimeZoneService {
	/**
	 * This function takes an IANA timezone such as "Europe/London" or "America/New_York"
	 * and a date string in UTC i.e. "2022-01-07T06:17:47.000Z".
	 *
	 * The function will then figure out what the offset from UTC is at that timezone
	 * on that particular date and time (it can be an hour different based on whether
	 * that location is on daylight savings time or not).
	 *
	 * The offset from UTC can then be used in the Angular date pipe
	 */
	utcOffset(utcDateStr: string, ianaTimeZone: string): string {
		const offset = DateTime.fromISO(utcDateStr)
			.setZone(ianaTimeZone)
			.setLocale('en-US')
			.toFormat('ZZ');

		if (offset === 'Invalid DateTime') {
			return 'UTC+00:00';
		}

		return 'UTC' + offset;
	}
}
